import { combineReducers, createStore } from 'redux';
import throttle from 'lodash/throttle';
import ModalReducer from './ModalReducer';
import SidebarReducer from './SidebarReducer';
import BasketReducer from './BasketReducer';
import AuthReducer from './AuthReducer';
import { loadState, saveState } from '../services/localStorage';

const rootReducer = combineReducers({
  ModalReducer,
  BasketReducer,
  AuthReducer,
  SidebarReducer,
});

const persitedState = loadState();

const store = createStore(
  rootReducer,
  persitedState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

store.subscribe(throttle(() => {
  saveState({
    BasketReducer: store.getState().BasketReducer,
    AuthReducer: store.getState().AuthReducer,
  });
}, 1000));

export default store;
